import {
  capitalizeEveryWord
} from "./chunk-FE7NU5ES.mjs";

// src/accreditation.ts
var PRO_LETTER = "PRO_LETTER";
var INCOME_VERIFICATION = "INCOME_VERIFICATION";
var ASSET_VERIFICATION = "ASSET_VERIFICATION";
var SECURITIES_PROFESSIONAL_EXEMPT = "SECURITIES_PROFESSIONAL_EXEMPT";
var INVESTOR_ACCREDITATION_OPTIONS = [
  { label: "Accredited Investor Verification Letter", value: PRO_LETTER },
  { label: "Income Verification", value: INCOME_VERIFICATION },
  { label: "Asset Verification", value: ASSET_VERIFICATION }
];
var ACCREDITATION_OPTIONS = [
  { label: "Accredited Investor Verification Letter", value: PRO_LETTER },
  { label: "Income Verification", value: INCOME_VERIFICATION },
  { label: "Asset Verification", value: ASSET_VERIFICATION },
  {
    label: "Securities Professional / Exempt",
    value: SECURITIES_PROFESSIONAL_EXEMPT
  }
];
var getAccreditationOptionsForOffering = (offering, offeringIsRule506c) => {
  const baseOptions = [
    { label: "Accredited Investor Verification Letter", value: PRO_LETTER },
    { label: "Income Verification", value: INCOME_VERIFICATION },
    { label: "Asset Verification", value: ASSET_VERIFICATION }
  ];
  if (offeringIsRule506c(offering)) {
    return [
      ...baseOptions,
      {
        label: "Securities Professional / Exempt",
        value: SECURITIES_PROFESSIONAL_EXEMPT
      }
    ];
  }
  return baseOptions;
};
var ASSET_OPTIONS = [
  {
    label: "Bank Statement",
    value: "BANK_STATEMENT"
  },
  {
    label: "Brokerage Statement",
    value: "BROKERAGE_STATEMENT"
  },
  {
    label: "Corporate 1120",
    value: "CORPORATE_1120"
  },
  {
    label: "Employee Benefit Plan",
    value: "EMPLOYEE_BENEFIT_PLAN"
  },
  {
    label: "Entity Assets",
    value: "ENTITY_ASSETS"
  },
  {
    label: "Trust Assets",
    value: "TRUST_ASSETS"
  },
  {
    label: "Other",
    value: "OTHER"
  }
];
var INCOME_OPTIONS = [
  {
    label: "1040 (US Citizen)",
    value: "PERSONAL_1040"
  },
  {
    label: "Other (US Citizen)",
    value: "PERSONAL_US_OTHER"
  },
  {
    label: "W-8 (Non-US Citizen)",
    value: "PERSONAL_W8"
  },
  {
    label: "Other (Non-US Citizen)",
    value: "PERSONAL_NON_US_OTHER"
  }
];
var PENDING = "PENDING";
var SUBMITTED = "SUBMITTED";
var APPROVED = "APPROVED";
var REJECTED = "REJECTED";
var AccreditationMethod = /* @__PURE__ */ ((AccreditationMethod2) => {
  AccreditationMethod2["PRO_LETTER"] = "PRO_LETTER";
  AccreditationMethod2["INCOME_VERIFICATION"] = "INCOME_VERIFICATION";
  AccreditationMethod2["ASSET_VERIFICATION"] = "ASSET_VERIFICATION";
  AccreditationMethod2["PLAID_REPORT"] = "PLAID_REPORT";
  AccreditationMethod2["SECURITIES_PROFESSIONAL_EXEMPT"] = "SECURITIES_PROFESSIONAL_EXEMPT";
  return AccreditationMethod2;
})(AccreditationMethod || {});
var VaultDocumentType = /* @__PURE__ */ ((VaultDocumentType2) => {
  VaultDocumentType2["VERIFICATION_REPORT"] = "VERIFICATION_REPORT";
  VaultDocumentType2["PROOF_OF_ADDRESS"] = "PROOF_OF_ADDRESS";
  return VaultDocumentType2;
})(VaultDocumentType || {});
var PlaidAuthStatus = /* @__PURE__ */ ((PlaidAuthStatus2) => {
  PlaidAuthStatus2["CREATED"] = "CREATED";
  PlaidAuthStatus2["PENDING"] = "PENDING";
  PlaidAuthStatus2["COMPLETED"] = "COMPLETED";
  PlaidAuthStatus2["FAILED"] = "FAILED";
  return PlaidAuthStatus2;
})(PlaidAuthStatus || {});
var PLAID_REPORT_NAME = {
  CRA: "Plaid Consumer Report",
  INCOME: "Plaid Income Results"
};
var AccreditationStatus = /* @__PURE__ */ ((AccreditationStatus2) => {
  AccreditationStatus2["PENDING"] = "PENDING";
  AccreditationStatus2["SUBMITTED"] = "SUBMITTED";
  AccreditationStatus2["APPROVED"] = "APPROVED";
  AccreditationStatus2["REJECTED"] = "REJECTED";
  return AccreditationStatus2;
})(AccreditationStatus || {});
var STATUS_OPTIONS = [
  {
    label: capitalizeEveryWord(PENDING),
    value: PENDING
  },
  {
    label: capitalizeEveryWord(SUBMITTED),
    value: SUBMITTED
  },
  {
    label: capitalizeEveryWord(APPROVED),
    value: APPROVED
  },
  {
    label: capitalizeEveryWord(REJECTED),
    value: REJECTED
  }
];
var buildSimpleOptions = (values) => values.map((value) => ({
  label: value,
  value
}));
var MARITAL_STATUS = ["Single", "Married", "Divorced", "Domestic Partner", "Widowed"];
var maritalStatusOptions = buildSimpleOptions(MARITAL_STATUS);
var EMPLOYMENT_STATUS = ["Student", "Employed", "Retired", "Self Employed", "Unemployed"];
var employmentStatusOptions = buildSimpleOptions(EMPLOYMENT_STATUS);
var ASSOCIATIONS = [
  "I am an affiliate of a broker-dealer or registered investment advisor",
  "I am a director or stakeholder of a public company",
  "I am a foreign government official or related to one"
];
var associationsOptions = buildSimpleOptions(ASSOCIATIONS);
var INVESTMENT_OBJECTIVES = ["Speculation", "Capital Preservation", "Income", "Growth"];
var investmentObjectiveOptions = buildSimpleOptions(INVESTMENT_OBJECTIVES);
var PlaidFilenames = {
  CRA: (id) => `vault/plaid-consumer-report-${id}`,
  Income: (id) => `vault/income-file-${id}`
};
export {
  ACCREDITATION_OPTIONS,
  APPROVED,
  ASSET_OPTIONS,
  ASSET_VERIFICATION,
  AccreditationMethod,
  AccreditationStatus,
  INCOME_OPTIONS,
  INCOME_VERIFICATION,
  INVESTOR_ACCREDITATION_OPTIONS,
  PENDING,
  PLAID_REPORT_NAME,
  PRO_LETTER,
  PlaidAuthStatus,
  PlaidFilenames,
  REJECTED,
  SECURITIES_PROFESSIONAL_EXEMPT,
  STATUS_OPTIONS,
  SUBMITTED,
  VaultDocumentType,
  associationsOptions,
  employmentStatusOptions,
  getAccreditationOptionsForOffering,
  investmentObjectiveOptions,
  maritalStatusOptions
};
//# sourceMappingURL=accreditation.mjs.map